function normalizeApiBaseUrl(value) {
  return String(value || '').trim().replace(/\/+$/, '');
}

export const DESERT_DEV_API_BASE_URL = normalizeApiBaseUrl(import.meta.env.VITE_DESERT_DEV_API_BASE_URL);

const DESERT_DEV_STATIC_WEB_APP_RE = /^zealous-desert-07e60460f(?:-[^.]+\.eastus2)?\.7\.azurestaticapps\.net$/i;

export function resolveApiBaseUrl({
  configured = import.meta.env.VITE_API_BASE_URL,
  hostname = typeof window !== 'undefined' ? window.location.hostname : '',
  desertDevApiBaseUrl = DESERT_DEV_API_BASE_URL,
} = {}) {
  const explicit = normalizeApiBaseUrl(configured);
  if (explicit) return explicit;

  const desertDevApiBase = normalizeApiBaseUrl(desertDevApiBaseUrl);
  const host = String(hostname || '').trim().toLowerCase();
  if (desertDevApiBase && DESERT_DEV_STATIC_WEB_APP_RE.test(host)) return desertDevApiBase;

  return '';
}

export const API_BASE_URL = resolveApiBaseUrl();